import { render, staticRenderFns } from "./FactorToggle.vue?vue&type=template&id=5d98f5e4&scoped=true&"
import script from "./FactorToggle.vue?vue&type=script&lang=ts&"
export * from "./FactorToggle.vue?vue&type=script&lang=ts&"
import style0 from "./FactorToggle.vue?vue&type=style&index=0&id=5d98f5e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d98f5e4",
  null
  
)

export default component.exports